export default "__VITE_ASSET__DGtjvDQ___"